import Api from './Api';
import Csrf from "./Csrf";

export default {
   
    async updateOrCreateSupport(form){
        await Csrf.getCookie();
        return Api.post('/create/support', form);
    },
    async getSupport(){
        await Csrf.getCookie();
        return Api.get('/get/institution/support/');
    },
    async getInstitutionSupportInfo(institution_id){
        await Csrf.getCookie(institution_id );
        return Api.get('/get/institution/support/'+institution_id);
    },
    async checkSupport(){
        await Csrf.getCookie();
        return Api.get('/check/institution/support/');
    },


    
};
